// components/blog/PublishToggle.js
import React from 'react';
import { Switch } from '@headlessui/react';
import { useFormContext, useWatch } from 'react-hook-form';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const PublishToggle = () => {
  const { setValue } = useFormContext();
  const isPublished = useWatch({ name: 'is_published' });

  return (
    <Switch.Group as="div" className="flex items-center justify-between">
      <Switch.Label className="text-sm text-gray-700">Publicado</Switch.Label>
      <Switch
        checked={isPublished}
        onChange={(val) => setValue('is_published', val)}
        className={classNames(
          isPublished ? 'bg-indigo-600' : 'bg-gray-300',
          'relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200'
        )}
      >
        <span
          className={classNames(
            isPublished ? 'translate-x-6' : 'translate-x-1',
            'inline-block h-4 w-4 transform rounded-full bg-white transition-transform'
          )}
        />
      </Switch>
    </Switch.Group>
  );
};

export default PublishToggle;
